import type { Presentation } from '@features/powerpoint';
import { titleSlideV2 } from '../../../../slides/title-slide-v2';
import {
  createSharedPresentationConfigV2,
  MASTER_NAMES,
} from '../../../../utils/shared-presentation-config-v2';
import { overviewSlideFromPropsV2 } from './build-overview-slide';
import { executiveSummarySlideFromPropsV2 } from './build-executive-summary-slide';
import { visitLiftTitleSlideV2 } from '../../slides/v2/visit-attribution/visit-lift-title-slide';
import { overallCampaignResultsSlideV2 } from '../../slides/v2/visit-attribution/overall-campaign-results';
import { salesAttributionSlidesV2 } from '../../slides/v2/sales-attribution-slides';
import { campaignAnalyticsSlidesV2 } from '../../slides/v2/campaign-analytics/build-campaign-analytics-slides-v2';
import { appendixSlidesFromPropsV2 } from '../../slides/v2/appendix/config';
import type { BuildPresentationProps } from '../build-presentation';

const visitLiftTitleSlideFromProps = (props: BuildPresentationProps) =>
  props.customFields.includedSlides.footTraffic.titleSlide
    ? [visitLiftTitleSlideV2()]
    : [];

const overallCampaignResultsFromProps = (
  props: BuildPresentationProps,
  slideMaster: string
) =>
  props.customFields.includedSlides.footTraffic.overallResults
    ? [
        overallCampaignResultsSlideV2({
          slideMaster,
          totalVisits: props.visitMetrics.projectedVisits ?? 0,
          incrementalVisits: props.visitMetrics.incrementalVisits ?? 0,
          incrementalLift: props.visitMetrics.incrementalLift ?? 0,
          costPerVisit: props.calculatedFields.costPerVisit ?? 0,
          costPerIncrementalVisit:
            props.calculatedFields.costPerIncrementalVisit ?? 0,
          confidenceLevel: props.visitMetrics.confidenceLevel ?? 0,
          ftaOverallResults: props.customFields.ftaOverallResults,
        }),
      ]
    : [];

export const buildPresentationV2 = (
  props: BuildPresentationProps
): Presentation => {
  const sharedConfig = createSharedPresentationConfigV2({
    campaign: props.campaign,
    brandLogo: props.brandLogo,
  });

  return {
    ...sharedConfig,
    filename: `${props.campaign.name}_lci_report_${props.selectedReportDate}.pptx`,
    slides: [
      titleSlideV2({
        campaign: { id: props.campaign.id, name: props.campaign.name },
        brandLogo: props.brandLogo,
      }),
      ...overviewSlideFromPropsV2(props, MASTER_NAMES.titleAndContent),
      ...executiveSummarySlideFromPropsV2(props, MASTER_NAMES.titleAndContent),
      ...visitLiftTitleSlideFromProps(props),
      ...overallCampaignResultsFromProps(props, MASTER_NAMES.titleAndContent),
      ...salesAttributionSlidesV2(props, MASTER_NAMES.titleAndContent),
      ...campaignAnalyticsSlidesV2(props, MASTER_NAMES.titleAndContent),
      ...appendixSlidesFromPropsV2(props),
    ],
  };
};
